import { FC } from "react";
import { useSelector } from "react-redux";
import { AnimatePresence } from "framer-motion";

import { RootState } from "@/utils/store";
import Dialog from "./Dialog";

const AlertDialogs: FC = () => {
  const { show, ...state } = useSelector((state: RootState) => state.alerts);

  return <AnimatePresence>{show && <Dialog state={state} />}</AnimatePresence>;
};

export default AlertDialogs;
